import React, { useState } from "react";
import { Divider, withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import {
  getFarmKml,
  setMapCenterCoordinates,
} from "features/manejo/redux/actions/farmActions";
import BotaoUpload from "features/shared/components/BotaoUpload";
import _ from "lodash";
import { connect } from "react-redux";
import { exportPastureCSV, saveCSV } from "services/PastureCsv";
import * as actions from "redux/actions";
import { exibirCarregando } from "redux/actions/loadingAction";
import * as notificaoActions from "redux/actions/notificacaoActions";
import LeitorArquivo from "lib/LeitorArquivo";
import Auth from "../../../../authentication/Auth";
import KMLFazenda from "../UploadKml/KMLFazenda";
import MenuLateralKML from "../UploadKml/MenuLateralKML";
import { Trans, useTranslations } from "adapters/i18n";
import { downloadBlobFile } from "lib/downloadArquivo";

function PastureOptions({
  carregarCoordPastos,
  classes,
  currentFarm,
  disable,
  exibirCarregando,
  fazendaSelecionada,
  getFarmKml,
  history,
  kmlFarmInfo,
  listaPastos,
  notifyError,
  notifyInfo,
  notifySuccess,
  notifyWarning,
  pastos,
  setCadastrandoKml,
  setCoordenadasFazenda,
  setFazendaInfo,
}) {
  const { t } = useTranslations();
  const [leitorArquivo] = useState(new LeitorArquivo());
  const [kmlHandler] = useState(new KMLFazenda());
  const [tipoUpload, setTipoUpload] = useState("");

  const newPastureClick = () => {
    const path = pastos.length
      ? "/cadastro_novo_pasto"
      : "/cadastro_nova_fazenda";
    history.push(path);
  };

  const routeChangeRetiro = () => {
    const path = "/cadastro_retiro";
    history.push(path);
  };

  const onEditClick = () => {
    history.replace("cadastro_editar_pasto");
  };

  const onInputFileOpen = (tipoUpload, extensao) => {
    leitorArquivo.setExtensaoArquivo(extensao);
    setTipoUpload(tipoUpload);
  };

  const updateFarmCoordenates = ({ Retiros }) => {
    const pastoReferencia = kmlHandler.getPastoReferencia(Retiros, notifyInfo);
    if (!_.isEmpty(pastoReferencia)) {
      setCoordenadasFazenda(pastoReferencia.Centro);
      carregarCoordPastos(kmlHandler.getPastosCoordenadas()); // salvar pastos no redux (inclusive pastos dentro de modulos)
      notifySuccess({
        mensagem: t("success:pasture.upload-success"),
        variant: "success",
      });
      setCadastrandoKml(true);
      kmlHandler.resetCoordenadasPastos();
    }
  };

  const trataBinarioArquivo = async (binarioArquivo) => {
    try {
      const IdFazenda = fazendaSelecionada;

      if (binarioArquivo) {
        if (tipoUpload === "kmlPasto") {
          await saveKMLFile(IdFazenda, binarioArquivo);
        } else if (tipoUpload === "csvPasto") {
          await saveCSVFile(IdFazenda, binarioArquivo);
        }
      }
    } catch (error) {
      exibirCarregando(false);
      notifyError({
        mensagem:
          error.name === "nomeRepetido"
            ? error.message
            : t("errors:pasture.non-standard-kml"),
      });
    }
  };

  const saveKMLFile = async (IdFazenda, binarioArquivo) => {
    const fazendaInfo = kmlHandler.montaEstruturaParaSalvar(
      binarioArquivo,
      IdFazenda
    );

    if (fazendaInfo.erro) {
      return;
    }

    const pastoRepetido = [];

    fazendaInfo.Retiros.forEach((retiro) => {
      pastoRepetido.push(
        retiro.Pastos.filter((pasto) => {
          const pastosRepetidos = retiro.Pastos.filter(
            (p) => p.Nome === pasto.Nome
          );
          return pastosRepetidos.length > 1;
        })
      );
    });

    if (pastoRepetido.some((p) => p.length > 0)) {
      const errorMessage = {
        name: "nomeRepetido",
        message: t("errors:pasture.repeated-names-in-retreat"),
      };
      throw errorMessage;
    }

    updateFarmCoordenates(fazendaInfo);
    setFazendaInfo(fazendaInfo);
  };

  const saveCSVFile = async (IdFazenda, binarioArquivo) => {
    exibirCarregando(true);

    const salvaCSV = await saveCSV(
      binarioArquivo.replace(/ï»¿/g, ""),
      IdFazenda
    );

    exibirCarregando(false);

    if (salvaCSV.erro) {
      notifyError({ mensagem: salvaCSV.erro });
      return;
    }

    listaPastos(IdFazenda);

    if (salvaCSV.warning) {
      notifyWarning({ mensagem: salvaCSV.warning });
      return;
    }

    notifySuccess({ mensagem: t("success:pasture.update-success") });
  };

  const onDrop = (files) => {
    leitorArquivo.lerArquivo(files, (resultado) => {
      if (resultado.concluido) {
        trataBinarioArquivo(resultado.fileAsBinaryString);
      } else {
        notifyInfo({ mensagem: resultado.motivo });
      }
    });
  };

  const onDropKML = (files) => {
    leitorArquivo.lerArquivoKML(files, (resultado) => {
      if (resultado.concluido) {
        trataBinarioArquivo(resultado.fileAsBinaryString);
      } else {
        notifyInfo({ mensagem: resultado.motivo });
      }
    });
  };

  const validaInputArquivo = (accepted, rejected) => {
    const respostaInputArquivo = leitorArquivo.validaInputArquivo(
      accepted,
      rejected
    );

    if (respostaInputArquivo.entradaArquivoValido) {
      onDrop(accepted);
    } else {
      notifyInfo({ mensagem: respostaInputArquivo.mensagem });
    }
  };

  const validaInputArquivoKML = (accepted, rejected) => {
    const respostaInputArquivo = leitorArquivo.validaInputArquivo(
      accepted,
      rejected
    );
    if (respostaInputArquivo.entradaArquivoValido) {
      onDropKML(accepted);
    } else {
      notifyInfo({ mensagem: respostaInputArquivo.mensagem });
    }
  };

  const exportarCSVCamposPastoCocho = () => {
    exportPastureCSV(fazendaSelecionada);
  };

  const importCsvConfirmMessage = (className) => (
    <div className={className}>
      <Trans
        i18nKey="pasture:import-csv-confirm-message"
        components={{ bold: <b />, p: <p /> }}
      />
    </div>
  );

  const downloadKmlFazenda = async () => {
    exibirCarregando(true);
    const kmlResponse = await getFarmKml(fazendaSelecionada);
    exibirCarregando(false);

    if (!kmlResponse) {
      return;
    }

    downloadBlobFile(
      currentFarm.Nome ? "mapa-" + currentFarm.Nome + ".kml" : "mapa.kml",
      kmlResponse,
      "application/vnd.google-earth.kml+xml"
    );
  };

  const { permissions } = Auth.getSession();

  const {
    containerInfo,
    containerBotao,
    dialogConfirm,
    buttonLabel,
    button,
    divider,
    subtitle,
  } = classes;

  if (kmlFarmInfo) {
    return <MenuLateralKML />;
  }

  return (
    <div data-testid="containerCadastroPasto">
      <div className={containerInfo}>
        <Typography variant="subtitle2" className={subtitle}>
          {t("pasture:select-desired-option")}
        </Typography>
      </div>

      {pastos.length > 0 && (
        <div className={containerBotao}>
          <span className={buttonLabel}>
            {t("pasture:edit-registered-pastures")}
          </span>
          <Button
            className={button}
            variant="contained"
            color="primary"
            type="button"
            onClick={onEditClick}
          >
            {t("pasture:edit-pasture")}
          </Button>
        </div>
      )}
      <div className={containerBotao}>
        <span className={buttonLabel}>{t("pasture:register-new-pasture")}</span>
        <Button
          className={button}
          variant="contained"
          color="primary"
          type="button"
          onClick={() => newPastureClick()}
        >
          {t("pasture:new-pasture")}
        </Button>
      </div>
      <div className={containerBotao}>
        <span className={buttonLabel}>{t("pasture:register-new-retreat")}</span>
        <Button
          className={button}
          variant="contained"
          color="primary"
          type="button"
          onClick={() => routeChangeRetiro()}
        >
          {t("pasture:new-retreat")}
        </Button>
      </div>
      {(permissions.importar_mapas ||
        permissions.exportar_importar_csv_pasto === "true") && (
        <Divider variant="middle" className={divider} />
      )}
      <div className={containerBotao}>
        <span className={buttonLabel}>{t("pasture:export-farm-kml")}</span>
        <Button
          className={button}
          variant="contained"
          color="primary"
          type="button"
          onClick={downloadKmlFazenda}
        >
          {t("pasture:export-map")}
        </Button>
      </div>
      {permissions.importar_mapas && (
        <div data-testid="containerImportacaoMapa">
          <div className={containerBotao}>
            <span className={buttonLabel}>{t("pasture:import-farm-kml")}</span>
            <BotaoUpload
              onInputFileOpen={onInputFileOpen}
              extensaoArquivoAceito=".kml"
              tipoUpload="kmlPasto"
              onDrop={validaInputArquivoKML}
              disabled={disable}
              tituloBotao={t("pasture:import-map")}
              cunstomClasses={containerBotao}
              buttomCustomClasses={button}
            />
          </div>
        </div>
      )}
      {permissions.exportar_importar_csv_pasto && (
        <div data-testid="containerPastoCSV">
          <div className={containerBotao}>
            <span className={buttonLabel}>
              {t("pasture:import-csv-for-pasture-edit")}
            </span>
            <BotaoUpload
              onInputFileOpen={onInputFileOpen}
              extensaoArquivoAceito=".csv"
              tipoUpload="csvPasto"
              onDrop={validaInputArquivo}
              disabled={disable}
              tituloBotao={t("pasture:import-csv")}
              confirmBefore={true}
              confirmTitle={t("pasture:import-csv")}
              confirmMessage={importCsvConfirmMessage(dialogConfirm)}
              confirmButtonText="Entendi"
              cunstomClasses={containerBotao}
              buttomCustomClasses={button}
            />
          </div>
          <div className={containerBotao}>
            <span className={buttonLabel}>
              {t("pasture:export-csv-description")}
            </span>
            <Button
              className={button}
              variant="contained"
              color="primary"
              type="button"
              onClick={() => exportarCSVCamposPastoCocho()}
            >
              {t("pasture:export-csv")}
            </Button>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  containerInfo: {
    margin: "32px 0px 16px 0px",
  },
  subtitle: {
    fontSize: "16px",
    fontFamily: "Roboto",
    letterSpacing: "normal",
  },
  buttonLabel: {
    fontFamily: "Roboto",
    color: "rgba(33, 33, 33, 0.7)",
    marginTop: 16,
    marginBottom: 8,
  },
  button: {
    textTransform: "none",
    fontSize: "16px",
    borderRadius: 4,
    width: "100%",
  },
  containerBotao: {
    display: "flex",
    flexDirection: "column",
    padding: 0,
    margin: 0,
  },
  dialogConfirm: {
    color: "#333333",
  },
  divider: {
    margin: "32px 0px 16px 0px",
  },
};

function mapStateToProps({ fazenda, pasto, kml }) {
  return {
    currentFarm: fazenda.currentFarm,
    fazendaSelecionada: fazenda.FazendaSelecionada,
    pastos: pasto.Pastos,
    kmlFarmInfo: kml.fazendaInfo,
  };
}

const mapDispatchToProps = {
  listaPastos: actions.listaPastos,
  habilitarDesenhar: actions.habilitarDesenhar,
  exibirCarregando,
  setCoordenadasFazenda: setMapCenterCoordinates,
  getFarmKml,
  ...notificaoActions,
  ...actions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PastureOptions));
